export default {
  code: "nl",
  brand: { name: "Tonouh", word: "Marketing" },
  nav: {
    home: "Home",
    services: "Onze diensten",
    about: "Over ons",
    contact: "Contact",
    cta: "Neem contact op",
    menu: "Menu openen",
    close: "Menu sluiten",
  },
  hero: {
    eyebrow: "Marketing & consultancy voor de kinderopvang",
    titleLines: ["Marketing en consultancy", "met focus op", "kinderopvang."],
    italicLine: 2,
    sub: "Tonouh Marketing helpt kinderopvangorganisaties hun positionering te versterken, ouders beter te bereiken en gericht te werken aan groei en organisatieontwikkeling. Met een bijzondere focus op de Nederlandse kinderopvangmarkt.",
    primaryCta: "Bespreek uw vraagstuk",
    secondaryCta: "Bekijk onze diensten",
    note: "Gevestigd in Ras Al Khaimah (UAE)",
    note2: "Actief in heel Europa",
    badgeMarkets: "Nederland · België · Duitsland · Frankrijk · Scandinavië",
    imgAlt: "Kinderen die aan een tafel werken in een warme, professionele groepsruimte",
  },
  marquee: ["Vertrouwen van ouders", "Lokale zichtbaarheid", "Bezetting", "Team & leiderschap", "Consistente communicatie", "Duurzame groei"],
  home: {
    intro: {
      eyebrow: "Kennismaking",
      title: "Een partner die kinderopvang begrijpt — én groei.",
      p1: "Tonouh Marketing FZ LLC is een gespecialiseerd marketing- en adviesbureau voor de kinderopvangsector. Wij werken met eigenaren, directies en managementteams van kinderdagverblijven en kinderopvangorganisaties — van enkele locaties tot organisaties met meerdere vestigingen.",
      p2: "Of u nu uw marktpositie wil scherpen, meer relevante aanvragen wil aantrekken, de communicatie met ouders wil versterken of organisatievraagstukken wil aanpakken: wij helpen u ambities om te zetten in een heldere, werkbare aanpak.",
      imgAlt: "Professionals in overleg rond een vergadertafel",
      link: "Meer over ons",
    },
    categories: {
      eyebrow: "Wat wij doen",
      title: "Drie richtingen, één focus: kinderopvang.",
      items: [
        { id: "marketing", index: "01", icon: "megaphone", title: "Marketing & Positionering", desc: "Onderscheid uzelf in uw lokale markt. Van markt- en doelgroepanalyse tot merkstrategie, online zichtbaarheid en campagnes die ouders bereiken — en interesse omzetten in rondleidingen en inschrijvingen.", link: "Bekijk deze dienst" },
        { id: "management", index: "02", icon: "briefcase", title: "Management & Organisatie", desc: "Strategie, leiderschap en organisatie. Praktisch advies over groeiplannen, management, processen, personeel en uitbreiding — gebaseerd op hoe kinderopvangorganisaties echt werken.", link: "Bekijk deze dienst" },
        { id: "assessments", index: "03", icon: "chart", title: "Assessments & Inzichten", desc: "Begrijp hoe ouders en medewerkers uw organisatie ervaren. Tevredenheidsonderzoeken en organisatieanalyses, vertaald naar een praktisch verbeterplan.", link: "Bekijk deze dienst" },
      ],
    },
    specialization: {
      eyebrow: "Sectorspecialisatie",
      title: "Waarom kinderopvang een andere markt is.",
      intro: "Kinderopvang is geen doorsnee dienstmarkt. Ouders nemen een van de belangrijkste beslissingen uit hun leven en kiezen een organisatie waar ze op vertrouwen. Dat vraagt om een andere aanpak dan generieke marketing.",
      items: [
        { icon: "shield", title: "Vertrouwen van ouders", desc: "Ouders kiezen met hart én hoofd. Vertrouwen is de doorslaggevende factor — opgebouwd door consequentie, transparantie en persoonlijke aandacht." },
        { icon: "map", title: "Lokale zichtbaarheid", desc: "Ouders zoeken dicht bij huis of werk. Lokale zichtbaarheid bepaalt of ze u überhaupt vinden." },
        { icon: "target", title: "Bezetting", desc: "Elke lege plek is structureel verlies. Bezetting volgt uit positionering, vindbaarheid en een goed georganiseerde inschrijfroute." },
        { icon: "users", title: "Medewerkers & leiderschap", desc: "Bevoegd personeel is overal schaars. Hoe u zich als werkgever presenteert, telt net zo zwaar als hoe u zich presenteert aan ouders." },
        { icon: "messages", title: "Consistente communicatie", desc: "Van eerste aanvraag tot dagelijkse update: elk contactmoment vormt de ouderervaring — en daarmee uw reputatie." },
      ],
      imgAlt: "Een rustige, goed georganiseerde kinteruimte van een kinderdagverblijf",
    },
    approach: {
      eyebrow: "Werkwijze",
      title: "Een heldere, rustige werkwijze.",
      steps: [
        { k: "01", title: "Kennismaken", desc: "We beginnen met een open, vrijblijvend gesprek over uw organisatie, uw markt en uw vraag." },
        { k: "02", title: "Analyseren", desc: "We brengen uw positie, uw ouders, uw zichtbaarheid en uw processen in kaart." },
        { k: "03", title: "Aanpak bepalen", desc: "Samen stellen we prioriteiten en een concreet plan vast dat past bij uw organisatie." },
        { k: "04", title: "Ondersteunen en evalueren", desc: "We ondersteunen de uitvoering, evalueren wat werkt en stellen bij waar nodig." },
      ],
    },
    europe: {
      eyebrow: "Werkgebied",
      title: "Europese focus. Nederlandse specialisatie.",
      p1: "Ons werkgebied is Europa, met een duidelijke specialisatie in de Nederlandse kinderopvangmarkt — een markt met eigen dynamiek, bekostiging en hoge verwachtingen van ouders. Daarnaast werken we met organisaties in België, Duitsland, Frankrijk en Scandinavië.",
      p2: "Tonouh is gevestigd in Ras Al Khaimah, Verenigde Arabische Emiraten, en werkt samen met organisaties in heel Europa — op afstand en hands-on.",
      marketsLabel: "Focusmarkten",
      markets: ["Nederland", "België", "Duitsland", "Frankrijk", "Scandinavië"],
    },
    closing: {
      title: "Welke vraag speelt er in uw organisatie?",
      body: "Vertel ons over uw kinderopvangorganisatie. Wij denken met u mee — open, praktisch en vrijblijvend.",
      cta: "Bespreek uw vraagstuk",
      email: "Of schrijf naar",
    },
  },
  services: {
    hero: {
      eyebrow: "Onze diensten",
      title: "Marketing en advies, gemaakt voor kinderopvang.",
      sub: "Drie dienstencategorieën met één startpunt: uw organisatie, uw ouders en uw markt. Elke opdracht begint met begrip — en eindigt in praktisch toepasbaar advies.",
    },
    categories: [
      {
        id: "marketing",
        index: "01",
        name: "Marketing & Positionering",
        tagline: "Gevonden worden, gekozen worden.",
        intro: "Hoe ouders u zien — en of ze u überhaupt vinden. Wij helpen u een onderscheidende positie op te bouwen in uw lokale markt en de juiste ouders te bereiken met de juiste boodschap.",
        imgAlt: "Een lichte speelruimte van een kinderdagverblijf met kleine tafels en stoelen",
        items: [
          "Markt- en doelgroepanalyse",
          "Merkstrategie en positionering",
          "Websitecontent en online zichtbaarheid",
          "Lokale marketing en campagnes",
          "Communicatie met ouders",
          "Analyse van de route van eerste interesse naar rondleiding en inschrijving",
          "Strategieën voor het aantrekken van relevante aanvragen en het verbeteren van bezetting",
        ],
        cta: "Bespreek marketing & positionering",
      },
      {
        id: "management",
        index: "02",
        name: "Management & Organisatieadvies",
        tagline: "Organisatie, leiderschap, groei.",
        intro: "Groeiende kinderopvangorganisaties krijgen te maken met vraagstukken die verder reiken dan marketing: leiderschap, processen, personeel en uitbreiding. Wij adviseren over de organisatiekant — met kennis van de sector.",
        imgAlt: "Een team van professionals in overleg aan een vergadertafel",
        items: [
          "Strategische groeiplannen",
          "Advies over management en leiderschap",
          "Begeleiding bij organisatieverandering",
          "Analyse en verbetering van werkprocessen",
          "Advies over personeelsplanning en medewerkersbehoud",
          "Ondersteuning bij uitbreiding of nieuwe locaties",
        ],
        cta: "Bespreek management & organisatie",
      },
      {
        id: "assessments",
        index: "03",
        name: "Assessments & Inzichten",
        tagline: "Inzicht vóór actie.",
        intro: "Hoe ervaren ouders uw organisatie? Waar lopen processen goed en waar lopen ze vast? Wij brengen het objectief in kaart en vertalen bevindingen naar een praktisch verbeterplan.",
        imgAlt: "Een kinderopvangprofessional in gesprek met een ouder en kind",
        items: [
          "Oudertevredenheidsonderzoeken",
          "Analyse van de ouderervaring",
          "Organisatie- en locatieanalyses",
          "Evaluatie van communicatie, processen en samenwerking",
          "Praktische verbeterplannen op basis van bevindingen",
        ],
        cta: "Vraag een assessment aan",
      },
    ],
    advisory: {
      title: "Adviserend van aard",
      body: "Onze assessments en analyses geven inzicht en richting. Het zijn geen officiële toezichthoudende inspecties en ze leiden niet tot certificering.",
    },
    uae: {
      eyebrow: "Naast Europa",
      title: "Kinderopvang starten in de UAE?",
      intro: "Verkent u de startmarkt in de Verenigde Arabische Emiraten? Wij ondersteunen de voorbereiding met onderzoek en positionering — dezelfde gestructureerde aanpak die wij in Europa toepassen.",
      items: ["Haalbaarheidsstudies voor nieuwe kinderopvanglocaties in de UAE", "Marktanalyse en positionering", "Ondersteuning bij voorbereiding en opstart"],
      note: "Adviserende ondersteuning bij markttoetreding. Geen uitkomst — inclusief vergunningverlening — kan worden gegarandeerd.",
      cta: "Bespreek uw UAE-plannen",
      interest: "uae",
    },
  },
  about: {
    hero: {
      eyebrow: "Over ons",
      title: "Marketing en advies, toegewijd aan kinderopvang.",
      sub: "Tonouh Marketing FZ LLC combineert marketing met organisatieadvies — voor kinderopvangorganisaties in heel Europa, met een duidelijke specialisatie in Nederland.",
    },
    story: {
      eyebrow: "Ons verhaal",
      title: "Gebouwd op begrip, geen sjablonen.",
      paras: [
        "Tonouh Marketing FZ LLC is een gespecialiseerd marketing- en adviesbureau voor de kinderopvangsector. Vanuit Ras Al Khaimah, in de Verenigde Arabische Emiraten, werken we met eigenaren, directies en managementteams in heel Europa — met een duidelijke specialisatie in de Nederlandse kinderopvangmarkt.",
        "Kinderopvangorganisaties krijgen te maken met twee soorten vragen. Hoe worden we zichtbaar voor ouders, nu en straks, en hoe presenteren we een sterke, onderscheidende positie? En: hoe organiseren we groei, management en de dagelijkse exploitatie in een sector waar kwaliteit en vertrouwen alles bepalen? Tonouh combineert beide bewust: marketing en organisatieadvies onder één dak.",
        "Onze aanpak begint altijd met begrip — van uw organisatie, uw ouders, uw team en uw lokale markt. Pas daarna adviseren wij. Geen standaarddraaiboeken, maar een praktische aanpak die past bij hoe kinderopvang werkt en waar uw team direct mee aan de slag kan.",
      ],
      imgAlt: "Collega's in gesprek tijdens een werksessie",
    },
    values: {
      eyebrow: "Kernwaarden",
      title: "Zo werken wij met u samen.",
      items: [
        { icon: "message", title: "Helderheid in communicatie", desc: "Eerlijk advies, gewone taal en reële verwachtingen. Geen jargon, geen illusies." },
        { icon: "handshake", title: "Betrokkenheid", desc: "Wij interesseren ons werkelijk voor uw organisatie. Uw vraag wordt onze vraag — tot die is opgelost." },
        { icon: "list", title: "Praktisch advies", desc: "Adviezen waar u mee aan de slag kunt: concreet, geprioriteerd en haalbaar met uw team." },
        { icon: "sprout", title: "Duurzame ontwikkeling", desc: "Groei die blijft. We bouwen aan posities en organisaties die op de lange termijn sterk blijven." },
      ],
    },
    location: {
      eyebrow: "Waar wij zitten",
      title: "Ras Al Khaimah, Verenigde Arabische Emiraten.",
      body: "Onze thuisbasis ligt in de UAE; onze focus ligt op Europa. We werken op afstand samen met kinderopvangorganisaties, in gestructureerde trajecten met duidelijke afspraken en korte lijntjes.",
      cta: "Neem contact op",
    },
  },
  contact: {
    hero: {
      eyebrow: "Contact & adviesaanvraag",
      title: "Vertel ons over uw kinderopvangorganisatie",
      sub: "Of u een concrete vraag heeft of nog aan het verkennen bent: laat uw gegevens achter, deel uw vraagstuk en wij reageren persoonlijk en zorgvuldig.",
    },
    info: {
      emailLabel: "E-mail",
      locationLabel: "Gevestigd in",
      locationValue: "Ras Al Khaimah, Verenigde Arabische Emiraten",
      areaLabel: "Werkgebied",
      areaValue: "Europa — met specialisatie in Nederland",
      confidentiality: "Wij gaan vertrouwelijk om met uw gegevens en gebruiken deze alleen om op uw aanvraag te reageren.",
    },
    form: {
      name: "Naam",
      namePh: "Uw naam",
      organization: "Organisatienaam",
      organizationPh: "Uw organisatie",
      email: "Zakelijk e-mailadres",
      emailPh: "naam@organisatie.nl",
      phone: "Telefoonnummer (optioneel)",
      phonePh: "+31 …",
      country: "Land",
      countryPh: "Selecteer uw land",
      countries: ["Nederland", "België", "Duitsland", "Frankrijk", "Luxemburg", "Denemarken", "Zweden", "Noorwegen", "Finland", "IJsland", "Oostenrijk", "Zwitserland", "Spanje", "Italië", "Portugal", "Ierland", "Verenigd Koninkrijk", "Verenigde Arabische Emiraten", "Overig"],
      website: "Website (optioneel)",
      websitePh: "www.uworganisatie.nl",
      locations: "Aantal locaties (optioneel)",
      locationsPh: "Selecteer",
      locationOptions: ["1", "2–5", "6–10", "Meer dan 10"],
      interest: "Interessegebied",
      interestPh: "Selecteer",
      interestOptions: [
        { v: "general", label: "Algemene vraag" },
        { v: "marketing", label: "Marketing & Positionering" },
        { v: "management", label: "Management & Organisatieadvies" },
        { v: "assessments", label: "Assessments & Inzichten" },
        { v: "uae", label: "Kinderopvang starten in de UAE" },
      ],
      message: "Uw vraag of uitdaging",
      messagePh: "Beschrijf kort uw organisatie en waar u graag hulp bij wil.",
      consent: "Houd mij op de hoogte van nieuwe diensten en inzichten van Tonouh Marketing (optioneel).",
      privacyNote: "Door dit formulier te versturen gaat u akkoord met de verwerking van uw gegevens zoals beschreven in onze",
      privacyLink: "privacyverklaring",
      required: "Verplicht",
      honeypot: "Fax",
      submit: "Verstuur uw aanvraag",
      sending: "Versturen…",
      errors: {
        name: "Vul uw naam in.",
        organization: "Vul de naam van uw organisatie in.",
        email: "Vul een geldig zakelijk e-mailadres in.",
        country: "Selecteer uw land.",
        message: "Beschrijf uw vraag of uitdaging (minimaal 20 tekens).",
      },
      success: {
        title: "Dank u — uw aanvraag is ontvangen.",
        body: "Wij bekijken uw bericht en reageren persoonlijk op uw e-mailadres.",
        again: "Nog een aanvraag versturen",
      },
      errorGeneral: "Er ging iets mis bij het versturen. Uw gegevens zijn bewaard — probeer het opnieuw.",
      errorRate: "U heeft in korte tijd meerdere aanvragen verstuurd. Probeer het later opnieuw.",
    },
  },
  privacy: {
    title: "Privacyverklaring",
    draftBadge: "Concept — te controleren vóór publicatie",
    intro: "Deze conceptprivacyverklaring beschrijft hoe Tonouh Marketing FZ LLC omgaat met persoonsgegevens, gebaseerd op de gegevensverwerking zoals deze op deze website daadwerkelijk is gebouwd. Gegevens gemarkeerd met [nog aan te vullen] moeten vóór publicatie worden gecontroleerd.",
    sections: [
      { h: "1. Wie is verantwoordelijk?", ps: ["Tonouh Marketing FZ LLC, gevestigd te Ras Al Khaimah, Verenigde Arabische Emiraten, is de verwerkingsverantwoordelijke voor de hieronder beschreven verwerking. [Volledig bezoekadres en inschrijfnummer — nog aan te vullen.] Vragen en verzoeken: info@tonouhmarketing.com."] },
      { h: "2. Welke gegevens verzamelen wij?", ps: ["Wanneer u het adviesaanvraagformulier op deze website invult, verzamelen wij:"], list: ["Uw naam en de naam van uw organisatie", "Uw zakelijk e-mailadres", "Uw telefoonnummer (optioneel)", "Uw land", "Uw website (optioneel)", "Het aantal locaties van uw organisatie (optioneel)", "Uw interessegebied", "Uw vraag of uitdaging", "Of u toestemming heeft gegeven voor marketingupdates (optioneel)"], ps2: ["Daarnaast bewaren wij bij elke aanvraag het IP-adres en het tijdstip van verzending. Wij gebruiken deze uitsluitend voor spambeveiliging en beveiliging. Wij vragen niet — en verzoeken u deze niet te sturen — om gegevens over individuele kinderen."] },
      { h: "3. Waarvoor gebruiken wij uw gegevens?", list: ["Om te reageren op uw vraag of uitdaging", "Om uw aanvraag binnen onze organisatie te bewaren en op te volgen", "Om onze website te beschermen tegen spam en misbruik (gerechtvaardigd belang)", "Om u af en toe updates te sturen over onze diensten en inzichten, uitsluitend als u daar expliciet toestemming voor heeft gegeven"], ps: ["Wij gebruiken uw gegevens voor geen enkel ander doel en verkopen deze nooit aan derden."] },
      { h: "4. Grondslag", ps: ["Wij verwerken uw gegevens op basis van ons gerechtvaardigd belang om uw aanvraag te behandelen en te beantwoorden. Marketingupdates versturen wij uitsluitend op basis van uw expliciete toestemming, die u op elk moment kunt intrekken via hetzelfde e-mailadres."] },
      { h: "5. Hoe lang bewaren wij uw gegevens?", ps: ["Aanvragen bewaren wij zo lang als nodig is om deze en eventuele opvolging te behandelen, en in ieder geval niet langer dan [bewaartermijn — nog te bevestigen] na ons laatste contact met u."] },
      { h: "6. Wie heeft toegang tot uw gegevens?", ps: ["Uw gegevens worden opgeslagen in de database van onze hostingpartij en zijn uitsluitend toegankelijk voor Tonouh Marketing. Onze hostingpartij kan gegevens verwerken buiten de Europese Economische Ruimte; wij zorgen voor passende waarborgen. Bij het versturen van een aanvraag ontvangen wij de gegevens ook per e-mail, verzonden via onze e-mailprovider. Wij verstrekken uw gegevens niet aan andere derden."] },
      { h: "7. Cookies en tracking", ps: ["Deze website gebruikt geen tracking- of advertentiecookies en draait geen analytics zonder uw toestemming."] },
      { h: "8. Uw rechten", ps: ["U heeft recht op inzage, correctie of verwijdering van uw gegevens, op bezwaar tegen verwerking en op intrekking van toestemming. Stuur uw verzoek naar info@tonouhmarketing.com en wij reageren zo snel mogelijk. Als u vindt dat wij uw gegevens niet correct verwerken, kunt u een klacht indienen bij de betrokken toezichthouder."] },
      { h: "9. Wijzigingen", ps: ["Wij kunnen deze privacyverklaring bijwerken wanneer onze verwerking van gegevens verandert. De meest recente versie staat altijd op deze pagina."] },
    ],
  },
  footer: {
    tagline: "Marketing en advies voor kinderopvangorganisaties — gericht op Europa, gespecialiseerd in Nederland.",
    navTitle: "Navigatie",
    contactTitle: "Contact",
    emailLabel: "info@tonouhmarketing.com",
    location: "Ras Al Khaimah, Verenigde Arabische Emiraten",
    area: "Werkgebied: Europa",
    privacy: "Privacyverklaring",
    rights: "© {year} Tonouh Marketing FZ LLC. Alle rechten voorbehouden.",
  },
  notFound: {
    title: "Pagina niet gevonden",
    body: "De pagina die u zoekt bestaat niet of is verplaatst.",
    cta: "Terug naar home",
  },
  meta: {
    home: { title: "Marketing & Consultancy voor Kinderopvang | Tonouh Marketing", description: "Tonouh Marketing helpt kinderopvangorganisaties met positionering, ouderbereik en gerichte groei. Specialist in de Nederlandse kinderopvangmarkt." },
    services: { title: "Onze Diensten — Marketing & Advies voor Kinderopvang | Tonouh", description: "Marketing & positionering, management- en organisatieadvies en assessments & inzichten — voor kinderopvangorganisaties in Europa en Nederland." },
    about: { title: "Over Tonouh Marketing — Marketing & Advies voor Kinderopvang", description: "Tonouh Marketing FZ LLC combineert marketing met organisatieadvies voor kinderopvangorganisaties in Europa, gevestigd in Ras Al Khaimah, UAE." },
    contact: { title: "Contact & Adviesaanvraag | Tonouh Marketing", description: "Deel uw vraagstuk met Tonouh Marketing. Specialist in marketing en consultancy voor kinderopvangorganisaties in Europa en Nederland." },
    privacy: { title: "Privacyverklaring | Tonouh Marketing", description: "Hoe Tonouh Marketing uw gegevens verzamelt, gebruikt en beschermt wanneer u contact met ons opneemt via onze website." },
  },
};
